import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

/**
 * A component for triggering interactions
 */
function CallToActionButton({ size, title, ariaLabel, isDisabled, onPress, children }) {
  return (
    <Button
      theme={'cta'}
      size={size}
      title={title}
      ariaLabel={ariaLabel}
      iconType={'chevron-right'}
      iconPosition={'right'}
      isDisabled={isDisabled}
      onPress={onPress}
    >
      {children}
    </Button>
  );
}

CallToActionButton.propTypes = {
  /**
   * The size of the button
   */
  size: PropTypes.oneOf(['medium']),
  /**
   * The title of the button
   */
  title: PropTypes.string,
  /**
   * The ARIA label of the button
   */
  ariaLabel: PropTypes.string,
  /**
   * The flag for disabling the control
   */
  isDisabled: PropTypes.bool,
  /**
   * The function to call when pressed
   */
  onPress: PropTypes.func,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default CallToActionButton;
